import { jsx as _jsx } from "react/jsx-runtime";
import { LogoImg } from "../../../assets/logo";
import { useContext } from "react";
import { SharedUiHeaderV2Context } from "../../context/context-shared-ui-header-v2";
import styles from "./logo-container.module.css";
export var LogoContainer = function() {
    var logicStore = useContext(SharedUiHeaderV2Context).logicStore;
    var handleTrackEvent = logicStore.handleTrackEvent;
    return /*#__PURE__*/ _jsx("li", {
        className: styles.logoWrapper,
        children: /*#__PURE__*/ _jsx("a", {
            href: "/",
            "aria-label": "cinch homepage",
            onClick: function() {
                return handleTrackEvent({
                    name: "click",
                    category: "mega menu",
                    label: "cinch logo",
                    action: "button"
                });
            },
            children: /*#__PURE__*/ _jsx(LogoImg, {})
        })
    });
};
